import { Gift, Calculator, Calendar, Tag, Info } from "lucide-react";
import HubGrid from "./HubGrid";
import "./theme.css";

function go(href) {
  window.history.pushState({}, "", href);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

const CARDS = [
  {
    id: "exemption",
    icon: Gift,
    title: "관세감면",
    meta: "관세법 제88~101조",
    desc: "외교관용·학술연구용·재수출조건부 등 용도·조건에 따른 감면. 조문별 대상·감면율 + AI 가이드.",
    href: "/?audit=exemption",
    accent: "#4338ca",
  },
  {
    id: "simplified-rate",
    icon: Calculator,
    title: "간이세율",
    meta: "관세법 제81조",
    desc: "여행자 휴대품·소액 특송 등에 관세와 내국세를 묶은 단일(품목류별) 세율. 적용조건·참고 세율표.",
    href: "/?audit=simplified-rate",
    accent: "#047857",
  },
  {
    id: "installment",
    icon: Calendar,
    title: "분할납부",
    meta: "관세법 제107조",
    desc: "납부기한 곤란(1년)·정책적 분할납부(5년) 유형과 대상, 사후관리 유의사항.",
    href: "/?audit=installment",
    accent: "#b45309",
  },
  {
    id: "enduse-rate",
    icon: Tag,
    title: "용도세율 · 사후관리",
    meta: "관세법 제83조",
    desc: "같은 세번이라도 용도에 따라 세율이 다를 때, 낮은 세율(용도세율) 적용 요건과 사후관리.",
    href: "/?audit=enduse-rate",
    accent: "#7c3aed",
  },
];

export default function CustomsGuideHubPage() {
  const cards = CARDS.map((c) => ({ ...c, onClick: () => go(c.href) }));

  const footer = (
    <div
      style={{
        border: "1px solid var(--audit-border)",
        borderRadius: 12,
        background: "var(--audit-bg-subtle)",
        padding: "14px 16px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 7,
          fontSize: 13.5,
          fontWeight: 800,
          marginBottom: 6,
        }}
      >
        <Info size={16} /> 그 밖의 제도는 세번 상세에서
      </div>
      <div
        style={{
          fontSize: 12.5,
          lineHeight: 1.7,
          color: "var(--audit-text-muted)",
        }}
      >
        <b>세율적용 우선순위</b>(원산지별 적용세율·관세법 제50조),{" "}
        <b>관세환급</b>(간이정액·개별), <b>내국세</b>(부가세·개별소비세 등)는
        세번마다 값이 달라 개별 세번 상세에서 확인합니다.{" "}
        <button
          onClick={() => go("/?audit=quickref&noextra=1")}
          style={{
            border: "none",
            background: "transparent",
            padding: 0,
            cursor: "pointer",
            fontFamily: "inherit",
            fontSize: 12.5,
            fontWeight: 600,
            color: "var(--audit-text)",
            textDecoration: "underline",
          }}
        >
          관세율표에서 세번 찾기 →
        </button>
      </div>
    </div>
  );

  return (
    <HubGrid
      title="관세제도"
      subtitle="감면·간이세율·분할납부·용도세율 등 주요 관세 제도를 한 곳에서 확인하세요. 각 제도의 적용 대상·요건·사후관리와 근거 조문(law.go.kr)을 안내합니다."
      cards={cards}
      footer={footer}
    />
  );
}
